module.exports = __webpack_public_path__ + "mo/img/piece-05.7ba36c55.svg";